// FIXME snake_case property names below violate our conventions

import Colors from 'common/constants/colors';

export const byResource = {
  electricity: {
    primary: Colors.yellow300,
    primaryHover: Colors.yellow200,
    underText: Colors.yellow100,
    underTextHover: Colors.yellow200,
  },
  gas: {
    primary: Colors.purple300,
    primaryHover: Colors.purple200,
    underText: Colors.purple100,
    underTextHover: Colors.purple200,
  },
  water: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  pv: {
    primary: Colors.green300,
    primaryHover: Colors.green200,
    underText: Colors.green100,
    underTextHover: Colors.green200,
  },
  workorders: {
    primary: Colors.green300,
    primaryHover: Colors.green200,
    underText: Colors.green100,
    underTextHover: Colors.green200,
  },
  energy: {
    primary: Colors.orange300,
    primaryHover: Colors.orange200,
    underText: Colors.orange100,
    underTextHover: Colors.orange200,
  },
  totalenergy: {
    primary: Colors.orange300,
    primaryHover: Colors.orange200,
    underText: Colors.orange100,
    underTextHover: Colors.orange200,
  },
  solar_thermal: {
    primary: Colors.orange300,
    primaryHover: Colors.orange200,
    underText: Colors.orange100,
    underTextHover: Colors.orange200,
  },
  geothermal: {
    primary: Colors.orange300,
    primaryHover: Colors.orange200,
    underText: Colors.orange100,
    underTextHover: Colors.orange200,
  },
  // (steam heating)
  heating: {
    primary: Colors.red300,
    primaryHover: Colors.red200,
    underText: Colors.red100,
    underTextHover: Colors.red200,
  },
  hot_water: {
    primary: Colors.red300,
    primaryHover: Colors.red200,
    underText: Colors.red100,
    underTextHover: Colors.red200,
  },
  // (chilled water)
  cooling: {
    primary: Colors.teal300,
    primaryHover: Colors.teal200,
    underText: Colors.teal100,
    underTextHover: Colors.teal200,
  },
  rainwater: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  grey_water: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  wind: {
    primary: Colors.yellow300,
    primaryHover: Colors.yellow200,
    underText: Colors.yellow100,
    underTextHover: Colors.yellow200,
  },
  co_gen: {
    primary: Colors.yellow300,
    primaryHover: Colors.yellow200,
    underText: Colors.yellow100,
    underTextHover: Colors.yellow200,
  },
  compost: {
    primary: Colors.green300,
    primaryHover: Colors.green200,
    underText: Colors.green100,
    underTextHover: Colors.green200,
  },
  waste: {
    primary: Colors.gray600,
    primaryHover: Colors.gray500,
    underText: Colors.gray500,
    underTextHover: Colors.gray600,
  },
  recycling: {
    primary: Colors.blue400,
    primaryHover: Colors.blue300,
    underText: Colors.blue300,
    underTextHover: Colors.blue400,
  },
  propane: {
    primary: Colors.blue400,
    primaryHover: Colors.blue300,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  other: {
    primary: Colors.blue400,
    primaryHover: Colors.blue300,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  energy_star_score: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  site_eui: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  site_eui_wn: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  source_eui: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  source_eui_wn: {
    primary: Colors.blue300,
    primaryHover: Colors.blue200,
    underText: Colors.blue100,
    underTextHover: Colors.blue200,
  },
  cdd: {
    primary: Colors.blue400,
    primaryHover: Colors.blue300,
    underText: Colors.blue300,
    underTextHover: Colors.blue400,
  },
  hdd: {
    primary: Colors.red400,
    primaryHover: Colors.red300,
    underText: Colors.red300,
    underTextHover: Colors.red400,
  },
};

export const getColorsForResource = (resource) => {
  const colors = byResource[resource];
  return colors ? colors : byResource.other;
};

// Arbitrary colors for charts with multiple arbitrary series
export const spectrum = Colors.spectrum.split(', ');
export const spectrumHover = Colors.spectrumHover.split(', ');
export const spectrumWithoutPrimaryColors = [
  Colors.teal300,
  Colors.purple200,
  Colors.green200,
  Colors.yellow200,
  Colors.blue200,
  Colors.orange200,
  Colors.teal200,
  Colors.red200,
  Colors.gray300,
];
